var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 136,
    viewBox: "0 0 169 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 108.519,
    y: 68.0667,
    width: 59.0727,
    height: 71.8547
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6.65px)",
      clipPath: "url(#bgblur_0_104_42_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 13.3053,
    d: "M135.82 85.123C133.749 81.536 129.162 80.307 125.575 82.378C121.988 84.449 120.759 89.036 122.83 92.623L140.29 122.865C142.361 126.452 146.948 127.681 150.535 125.61C154.122 123.539 155.351 118.952 153.28 115.365L135.82 85.123Z",
    fill: "url(#paint0_linear_104_42)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 82.4957,
    y: 64.7107,
    width: 64.1447,
    height: 80.6397
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6.65px)",
      clipPath: "url(#bgblur_1_104_42_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 13.3053,
    d: "M109.797 81.767C107.726 78.18 103.139 76.951 99.552 79.022C95.965 81.093 94.736 85.68 96.807 89.267L119.339 128.294C121.41 131.881 125.997 133.11 129.584 131.039C133.171 128.968 134.4 124.381 132.329 120.794L109.797 81.767Z",
    fill: "url(#paint1_linear_104_42)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 37.6317,
    y: 72.1356,
    width: 62.1067,
    height: 77.1097
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6.65px)",
      clipPath: "url(#bgblur_2_104_42_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 13.3053,
    d: "M64.933 89.192C62.862 85.605 58.275 84.376 54.688 86.447C51.101 88.518 49.872 93.105 51.943 96.692L72.437 132.189C74.508 135.776 79.095 137.005 82.682 134.934C86.269 132.863 87.498 128.276 85.427 124.689L64.933 89.192Z",
    fill: "url(#paint2_linear_104_42)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 61.6157,
    y: 69.9707,
    width: 59.0027,
    height: 71.7336
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6.65px)",
      clipPath: "url(#bgblur_3_104_42_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 13.3053,
    d: "M88.917 87.027C86.846 83.44 82.259 82.211 78.672 84.282C75.085 86.353 73.856 90.94 75.927 94.527L93.317 124.647C95.388 128.235 99.975 129.464 103.562 127.393C107.149 125.322 108.378 120.735 106.307 117.147L88.917 87.027Z",
    fill: "url(#paint3_linear_104_42)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -20,
    y: -20,
    width: 208.67,
    height: 151.718
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_4_104_42_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 20,
    d: "M76.643 0.375C97.452 0.375 114.547 11.649 123.874 30.162L123.978 30.368H124.209C149.65 30.368 168.295 47.732 168.295 70.715C168.295 93.505 150.052 111.343 126.467 111.343H34.581C23.689 111.343 15.142 107.859 9.32001 102.255C3.49801 96.65 0.375 88.9 0.375 80.312C0.375 65.456 9.78399 53.741 23.745 49.762L23.993 49.691L24.016 49.434C26.469 21.465 49.459 0.375 76.643 0.375Z",
    fill: "#B9DDFF",
    fillOpacity: 0.6,
    stroke: "url(#paint4_linear_104_42)",
    strokeWidth: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_104_42_clip_path",
    transform: "translate(-108.519 -68.0667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.82 85.123C133.749 81.536 129.162 80.307 125.575 82.378C121.988 84.449 120.759 89.036 122.83 92.623L140.29 122.865C142.361 126.452 146.948 127.681 150.535 125.61C154.122 123.539 155.351 118.952 153.28 115.365L135.82 85.123Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_104_42_clip_path",
    transform: "translate(-82.4957 -64.7107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.797 81.767C107.726 78.18 103.139 76.951 99.552 79.022C95.965 81.093 94.736 85.68 96.807 89.267L119.339 128.294C121.41 131.881 125.997 133.11 129.584 131.039C133.171 128.968 134.4 124.381 132.329 120.794L109.797 81.767Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_104_42_clip_path",
    transform: "translate(-37.6317 -72.1356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.933 89.192C62.862 85.605 58.275 84.376 54.688 86.447C51.101 88.518 49.872 93.105 51.943 96.692L72.437 132.189C74.508 135.776 79.095 137.005 82.682 134.934C86.269 132.863 87.498 128.276 85.427 124.689L64.933 89.192Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_104_42_clip_path",
    transform: "translate(-61.6157 -69.9707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.917 87.027C86.846 83.44 82.259 82.211 78.672 84.282C75.085 86.353 73.856 90.94 75.927 94.527L93.317 124.647C95.388 128.235 99.975 129.464 103.562 127.393C107.149 125.322 108.378 120.735 106.307 117.147L88.917 87.027Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_4_104_42_clip_path",
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.643 0.375C97.452 0.375 114.547 11.649 123.874 30.162L123.978 30.368H124.209C149.65 30.368 168.295 47.732 168.295 70.715C168.295 93.505 150.052 111.343 126.467 111.343H34.581C23.689 111.343 15.142 107.859 9.32001 102.255C3.49801 96.65 0.375 88.9 0.375 80.312C0.375 65.456 9.78399 53.741 23.745 49.762L23.993 49.691L24.016 49.434C26.469 21.465 49.459 0.375 76.643 0.375Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_104_42",
    x1: 128.287,
    y1: 93.421,
    x2: 139.973,
    y2: 88.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_104_42",
    x1: 103.374,
    y1: 91.987,
    x2: 114.988,
    y2: 86.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_104_42",
    x1: 58.064,
    y1: 98.64,
    x2: 69.704,
    y2: 93.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_104_42",
    x1: 81.369,
    y1: 95.299,
    x2: 93.057,
    y2: 90.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_104_42",
    x1: -0.00000211969,
    y1: 0.00000323637,
    x2: 169,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645504,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainy);
export default __webpack_public_path__ + "static/media/Rainy.423296d5f445b2a393c8415bd9a6d36a.svg";
export { ForwardRef as ReactComponent };